"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ticketRequestPolicy = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var ticketIdHeaderName = "ticket"; // Sets "ticketId" in request header

var ticketRequestPolicy = function ticketRequestPolicy(ticketId) {
  return {
    create: function create(nextPolicy) {
      return {
        sendRequest: function () {
          var _sendRequest = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(httpRequest) {
            var response;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    httpRequest.headers.set(ticketIdHeaderName, ticketId);
                    _context.next = 3;
                    return nextPolicy.sendRequest(httpRequest);

                  case 3:
                    response = _context.sent;
                    return _context.abrupt("return", response);

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function sendRequest(_x) {
            return _sendRequest.apply(this, arguments);
          }

          return sendRequest;
        }()
      };
    }
  };
};

exports.ticketRequestPolicy = ticketRequestPolicy;